import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import shadows from 'theme/atoms/shadows';
import breakpoints from 'theme/atoms/breakpoints';

export const Tag = styled.div<{
  $hasDescription?: boolean;
  $isActive?: boolean;
  $bg?: string;
  $borderColor?: string;
  $hoverBg?: string;
}>`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 34px;
  padding: 8px 12px 8px 8px;
  background-color: ${({ $isActive, $bg, $hoverBg }) =>
    $isActive ? $hoverBg || '#ebeced' : $bg || 'transparent'};
  border: 2px solid
    ${({ $isActive, $borderColor }) =>
      $isActive
        ? $borderColor || '#ebeced'
        : $borderColor || colours.neutral[200]};
  border-radius: 25px;
  overflow: hidden;
  box-sizing: border-box;
  cursor: ${({ $hasDescription }) => ($hasDescription ? 'pointer' : 'default')};
  transition: all 0.2s ease;

  ${({ $hasDescription, $isActive, $hoverBg }) =>
    $hasDescription &&
    !$isActive &&
    `
    &:hover {
      background-color: ${$hoverBg || '#ebeced'};
      border-color: ${$hoverBg || '#ebeced'};
    }
  `}
`;

export const TagIcon = styled.span<{ $stroke?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
    stroke: ${({ $stroke }) => $stroke || '#294148'};
    stroke-width: 2;
  }
`;

export const TagLabel = styled.span<{ $color?: string }>`
  font-family: 'Inter', sans-serif;
  font-weight: 650;
  font-size: 14px;
  line-height: 16px;
  color: ${({ $color }) => $color || '#294148'};
  white-space: nowrap;
`;

export const CustomPopover = styled.div`
  position: absolute;
  background-color: white;
  border-radius: 15px;
  box-shadow: ${shadows.XL};
  border: 1.5px solid ${colours.neutral[200]};
  padding: 16px;
  max-width: min(400px, calc(100vw - 32px));
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-wrap: break-word;
  z-index: 1300;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: calc(100vw - 32px);
  }

  @media (max-width: ${breakpoints.mobileL}) {
    left: 16px !important;
    right: auto !important;
    width: calc(100vw - 32px) !important;
    max-width: none;
  }
`;

export const PopoverTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 650;
  line-height: 20px;
  color: ${colours.neutral[900]};
  margin-bottom: 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const PopoverContent = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${colours.neutral[700]};
  word-wrap: break-word;
  overflow-wrap: break-word;
`;
